import React from 'react';

const WellnessGymCard = ({ title, subtitle, image, bgColor }) => {
  return (
    <div
      className="card"
      style={{ backgroundColor: bgColor }}
    >
      <div className="card-text">
        <h2 className="card-title">{title}</h2>
        <p className="card-subtitle">{subtitle}</p>
      </div>
      {/* <img src={image} alt={title} className="card-image" /> */}
    </div>
  );
};

export default WellnessGymCard;
